var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-iconWrapper"},[_c('SvgIcon',{attrs:{"type":_vm.iconType,"medium":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }